import React from 'react';

export default function UserAccountTypeFilter({ value, onChange }) {
  return (
    <select aria-label="Account type" value={value} onChange={event => onChange(event.target.value)}
      className="w-full sm:w-48 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500">
      <option value="">All account types</option>
      <option value="owner">Organization owners</option>
      <option value="member">Team members</option>
      <option value="independent">Independent accounts</option>
    </select>
  );
}
